import { render, staticRenderFns } from "./StoneTechnicalDrawing2D.vue?vue&type=template&id=2840e6b8&scoped=true"
import script from "./StoneTechnicalDrawing2D.vue?vue&type=script&lang=js"
export * from "./StoneTechnicalDrawing2D.vue?vue&type=script&lang=js"
import style0 from "./StoneTechnicalDrawing2D.vue?vue&type=style&index=0&id=2840e6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2840e6b8",
  null
  
)

export default component.exports